import { ButtonStyles, NavigationButtonText } from './NavigationButtonTypes';

export const DARK_BUTTON: ButtonStyles = 'dark';
export const LIGHT_BUTTON: ButtonStyles = 'light';

export const NEXT_DIRECTION: NavigationButtonText = 'Next';
export const BACK_DIRECTION: NavigationButtonText = 'Back';
export const USE_SHEPHERD: NavigationButtonText = 'Use Shepherd';
